import { useState, useEffect } from "react";
import {
    ModalOverlay,
    ModalContainer,
    ModalCloseButton
} from "./style";

const Modal = ({ isOpen, onClose, children }) => {
    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };
        
        if(isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = "auto";
        }
        
        document.addEventListener('keydown', handleEscape);
        
        return () => document.removeEventListener('keydown', handleEscape);
    }, [isOpen, onClose]);

    
    if (!isOpen) return null;
   
    return (
        <ModalOverlay onClick={onClose}>
            <ModalContainer onClick={e => e.stopPropagation()}>
                <ModalCloseButton onClick={onClose}>&times;</ModalCloseButton>
                {children}
            </ModalContainer>
        </ModalOverlay>
    );
};

export default Modal;
